import type { Meta, StoryFn } from '@storybook/react';

import { IconTile } from '@pega/cosmos-react-build';
import type { IconTileProps } from '@pega/cosmos-react-build';

import { getIconConfig, mockIconTileData, type RuleType } from './IconTile.mocks';

export default {
  title: 'Build/IconTile',
  component: IconTile,
  parameters: {
    docs: {
      description: {
        component:
          'IconTile is a visual component with icon and a prescribed color palette as background/foreground.'
      }
    }
  }
} as Meta;

interface IconTileStoryArgs {
  size: IconTileProps['size'];
  type: RuleType;
}

export const IconTileDemo: StoryFn<IconTileStoryArgs> = (args: IconTileStoryArgs) => {
  const { name, category, label, inverted } = getIconConfig(args.type);
  return (
    <IconTile
      name={name}
      size={args.size}
      inverted={inverted}
      category={category}
      label={label}
      set='streamline'
    />
  );
};

IconTileDemo.args = { size: 'm', type: 'Automation' };

IconTileDemo.argTypes = {
  size: {
    control: { type: 'inline-radio' },
    options: ['s', 'm', 'l', 'xl']
  },
  type: {
    control: { type: 'select' },
    options: Object.keys(mockIconTileData)
  }
};
